if (!customElements.get('wlsn-product-cards')) {
    class WLSNProductCards extends HTMLElement {
        constructor() {
            super();

            this.slider = this.querySelector('.js-wlsn-slider');
        }

        connectedCallback() {
            this.initFade();
        }

        initFade() {
            if (!this.slider) return;

            const checkSwiper = setInterval(() => {
                const swiper = this.slider.swiper;

                if (!swiper) return;

                clearInterval(checkSwiper);

                const updateFade = () => {
                    this.slider.classList.remove(
                        'has-left-fade',
                        'has-right-fade'
                    );

                    if (!swiper.isBeginning) {
                        this.slider.classList.add('has-left-fade');
                    }

                    if (!swiper.isEnd) {
                        this.slider.classList.add('has-right-fade');
                    }
                };

                updateFade();

                swiper.on('slideChange', updateFade);
                swiper.on('transitionEnd', updateFade);
                swiper.on('resize', updateFade);
            }, 100);
        }

        disconnectedCallback() {}
    }

    customElements.define('wlsn-product-cards', WLSNProductCards);
}